import { ReactNode, useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationToolOutputType from '../../../types/output-type'
import CreationToolStatus from '../../../types/status'
import { CreationToolUploadContext } from '../manager'
import Loader from './loader'
import Sticker from './sticker'

const Container = styled.div`
    position: relative;
`

const PreviewWrapper = styled.div`
    transition: opacity 0.2s ease-out;
`

const getPreviewComponent = (outputType: CreationToolOutputType): ReactNode => {
    switch (outputType) {
        case CreationToolOutputType.Sticker:
            return <Sticker />
        default:
            return null
    }
}

const CreationUploadPreview = () => {
    const { outputType } = useContext(CreationToolsContext)
    const { status } = useContext(CreationToolUploadContext)
    return (
        <Container>
            <PreviewWrapper style={{ opacity: status === CreationToolStatus.Idle ? 1 : 0.3 }}>
                {getPreviewComponent(outputType)}
            </PreviewWrapper>
            <Loader />
        </Container>
    )
}

export default CreationUploadPreview
